import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import type { CardGetter, QueryOptionsGetter } from '@/modules/common/types/ui.ts';
import UiSearchMultiple from '@/modules/ui/components/ui/UiSearchMultiple.vue';
import type { IconComponent } from '@/modules/common/types/icon.type.ts';
import type { Component } from 'vue';
import type Option from '@/modules/common/models/option/option.ts';

type SchemaSearchMultipleArgs<T extends string | number> = SchemaControlArgs & {
  placeholder?: string;
  getOptions: QueryOptionsGetter<T>;
  addIcon: IconComponent;
  getCard: CardGetter<T>;
  addText?: string;
  cardFooter?: Component;
  max?: number;
  iconSpaced?: boolean;
  addOption?: (query: string) => void | Promise<void>;
  addOptionLabel?: string;
  onAddClick?: () => void;
};

export class SchemaSearchMultiple<T extends string | number> extends SchemaControl<Option<T>> {
  readonly component = UiSearchMultiple;
  readonly placeholder?: string;
  readonly getOptions: QueryOptionsGetter<T>;
  readonly addIcon: IconComponent;
  readonly getCard: CardGetter<T>;
  readonly addText?: string;
  readonly cardFooter?: Component;
  readonly max?: number;
  readonly iconSpaced?: boolean;
  readonly addOption?: (query: string) => void | Promise<void>;
  readonly addOptionLabel?: string;
  readonly onAddClick?: () => void;

  constructor(args: SchemaSearchMultipleArgs<T>) {
    super(args);

    this.placeholder = args.placeholder;
    this.getOptions = args.getOptions;
    this.addIcon = args.addIcon;
    this.getCard = args.getCard;
    this.addText = args.addText;
    this.cardFooter = args.cardFooter;
    this.max = args.max;
    this.iconSpaced = args.iconSpaced;
    this.addOption = args.addOption;
    this.addOptionLabel = args.addOptionLabel;
    this.onAddClick = args.onAddClick;
  }
}
